import { IDocument } from '@pf/shared-common';

function isDocumentDeleted(f: IDocument): boolean {
    return f.isDeleted === true;
}

function isDocumentDefault(f: IDocument): boolean {
    return f.isDefault === true;
}

export function pickDefaultItemFile(
    files: IDocument[] | null | undefined
): IDocument | null {
    const list = (files ?? []).filter(f => !isDocumentDeleted(f));
    if (!list.length) {
        return null;
    }
    return list.find(f => isDocumentDefault(f)) ?? list[0] ?? null;
}
